import { render, staticRenderFns } from "./ReportTotalHeader.vue?vue&type=template&id=00c9b9e6&"
import script from "./ReportTotalHeader.vue?vue&type=script&lang=js&"
export * from "./ReportTotalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports